import React from 'react'
import {connect} from 'react-redux'
import Modal from 'react-modal';
import {defaultModalStypes} from "./ModalsConstants";

Modal.setAppElement(document.getElementById('root'));

const MessageModal = props => {
  const {closeModal, content, windowSize} = props;

  const styles = defaultModalStypes;
  styles.content.width = (windowSize.width * 0.8) + 'px';

  return (
    <div>
      <Modal
        isOpen={true}
        onRequestClose={closeModal}
        style={styles}
        contentLabel="Persona Form"
      >
        <div className="inmodal hmodal-danger">
          <div className="color-line"></div>
          <div className="modal-header modal-header-padding">
            <h4 className="modal-title">{content.title}</h4>
          </div>
          <div className="modal-body" style={{
            maxHeight: (windowSize.height * 0.7) + 'px',
            maxWidth: (windowSize.width * 0.8) + 'px',
            overflow: 'scroll'
          }}>
            <pre>{content.message}</pre>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary2 col-xs-4 pull-right" onClick={closeModal}>
              <span className="btn-text">Close</span>
            </button>
          </div>
        </div>

      </Modal>
    </div>
  );
};

MessageModal.propTypes = {};

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  {}
)(MessageModal);




// WEBPACK FOOTER //
// ./src/common/modals/MessageModal.js